document.addEventListener('DOMContentLoaded',()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(!reduce){
    const io=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.style.setProperty('--delay',`${Math.min((entry.target.dataset.index||0)*55,330)}ms`);
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    },{threshold:.06,rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.product-section,.sale-banner,.why,.reviews,.about').forEach((el,i)=>{el.dataset.index=i;el.classList.add('reveal');io.observe(el)});
    document.querySelectorAll('.card').forEach((el,i)=>{el.dataset.index=i%8;el.classList.add('reveal-card');io.observe(el)});
  }

  const header=document.querySelector('.header');
  let last=0;
  window.addEventListener('scroll',()=>{
    const y=window.scrollY;
    if(header) header.classList.toggle('compact',y>30);
    last=y;
  },{passive:true});

  document.querySelectorAll('[data-product-card]').forEach(card=>{
    let selected=card.querySelector('.size-chip:not(.disabled)');
    if(selected){ selected.classList.add('selected'); const price=card.querySelector('[data-card-price]'); if(price) price.textContent=selected.dataset.variantPrice; }
    const btn=card.querySelector('[data-quick-add]');
    card.querySelectorAll('.size-chip').forEach(chip=>chip.addEventListener('click',()=>{
      card.querySelectorAll('.size-chip').forEach(x=>x.classList.remove('selected'));
      chip.classList.add('selected'); selected=chip; const price=card.querySelector('[data-card-price]'); if(price) price.textContent=chip.dataset.variantPrice;
    }));
    if(btn) btn.addEventListener('click',async()=>{
      if(!selected)return;
      btn.disabled=true; const old=btn.textContent; btn.textContent='ADDING…';
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(selected.dataset.variantId),quantity:1}]})});
        if(!r.ok)throw new Error();
        btn.textContent='ADDED ✓';
        document.body.classList.add('cart-transition');
        setTimeout(()=>{ window.location.href=(document.body.dataset.cartUrl||'/cart'); },520);
      }catch(e){btn.textContent='TRY AGAIN';setTimeout(()=>{btn.textContent=old;btn.disabled=false},1400)}
    });
  });
});
  const drawer=document.querySelector('[data-mobile-drawer]');
  const overlay=document.querySelector('[data-menu-overlay]');
  const openBtn=document.querySelector('.mobile-menu');
  const closeBtn=document.querySelector('[data-menu-close]');
  const openMenu=()=>{if(!drawer)return;drawer.classList.add('open');overlay.classList.add('open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('menu-open')};
  const closeMenu=()=>{if(!drawer)return;drawer.classList.remove('open');overlay.classList.remove('open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('menu-open')};
  openBtn&&openBtn.addEventListener('click',openMenu);
  closeBtn&&closeBtn.addEventListener('click',closeMenu);
  overlay&&overlay.addEventListener('click',closeMenu);
  drawer&&drawer.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
  document.querySelector('[data-collections-toggle]')?.addEventListener('click',()=>{
    const m=document.querySelector('[data-collections-menu]');
    const b=document.querySelector('[data-collections-toggle]');
    m.classList.toggle('open'); b.classList.toggle('open');
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeMenu()});


  document.querySelectorAll('[data-recommend-add]').forEach(btn=>btn.addEventListener('click',async()=>{
    const old=btn.textContent; btn.disabled=true; btn.textContent='ADDING…';
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(btn.dataset.variantId),quantity:1}]})});
      if(!r.ok) throw new Error();
      btn.textContent='ADDED ✓'; document.body.classList.add('cart-transition');
      setTimeout(()=>{window.location.href=(document.body.dataset.cartUrl||'/cart')},520);
    }catch(e){btn.textContent='TRY AGAIN';setTimeout(()=>{btn.textContent=old;btn.disabled=false},1200)}
  }));

  document.querySelectorAll('[data-qty-minus]').forEach(btn=>btn.addEventListener('click',()=>{
    const input=btn.parentElement.querySelector('input'); input.value=Math.max(0,Number(input.value||0)-1);
  }));
  document.querySelectorAll('[data-qty-plus]').forEach(btn=>btn.addEventListener('click',()=>{
    const input=btn.parentElement.querySelector('input'); input.value=Number(input.value||0)+1;
  }));
